import { sprinkles } from '@design-system/sprinkles.css';
import { ListItem } from './ListItem';
import { failedWrapper } from './VideoUploadStateModal.css';
import { Typography } from '@design-system/components/typography/typography';
import { clsx } from 'clsx';
import { UploadVideoVM } from '../../view-models/uploadVideo.viewModel';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

export const InvalidFilesList = ({
  invalidFiles,
  dispatch,
  uploadMap,
}: Pick<UploadVideoVM, 'dispatch'> &
  Pick<UploadVideoVM['list'], 'invalidFiles' | 'uploadMap'>) => {
  if (invalidFiles?.length === 0) return null;

  return (
    <div className="relative">
      <Accordion
        sx={{
          border: 0,
          boxShadow: 0,
          margin: 0,
          '&.MuiPaper-root:before': { content: 'none' },
          '&.MuiPaper-root.Mui-expanded': { margin: 0 },
          '&.MuiPaper-root > .MuiAccordionSummary-root': { maxWidth: 150 },
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={
            <FontAwesomeIcon
              icon={faChevronDown}
              className={sprinkles({ color: 'ERROR-100' })}
            />
          }
        >
          <Typography
            variant="bodyLarge"
            className={sprinkles({ color: 'ERROR-100' })}
          >
            Invalid files
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className={clsx(failedWrapper)}>
            {invalidFiles.map((item, index) => (
              <ListItem
                item={item}
                key={item.id}
                dispatch={dispatch}
                index={index}
              />
            ))}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
